import axiosInstance from 'utils/axiosInstance';
import { get } from 'lodash/fp';

export const getDiscountCodes = () => axiosInstance.get('/Coupons/GetAll').then(get('data'));
export const getDiscountCodeById = couponId => axiosInstance.get(`/Coupons/${couponId}`).then(get('data'));
export const postDiscountCodes = data => axiosInstance.post('/Coupons', data).then(get('data'));
export const putDiscountCodes = data => axiosInstance.put('/Coupons', data).then(get('data'));
export const deleteDiscountCodes = couponId => axiosInstance.delete(`/Coupons/${couponId}`).then(get('data'));
